import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';

type RoleType = {
  role_code: number;
  role_description: string;
};

export type SystemSliceState = {
  id: string;
  roles: RoleType[];
  image: string;
  email: string;
  username: string;
  isLogged: boolean;
};

const initState: SystemSliceState = {
  id: '',
  roles: [],
  image: '',
  email: '',
  username: '',
  isLogged: false,
};

const resetState = () => initState;

const setState: CaseReducer<SystemSliceState, PayloadAction<SystemSliceState>> = (
  state,
  action,
) => ({
  ...state,
  ...action.payload,
});

const systemSlice = createSlice({
  name: 'system',
  initialState: initState,
  reducers: {
    resetState,
    setState,
  },
});

export default systemSlice;
